import Axios from "axios";
import {
    SET_PENDING_SALE_ORDER_LIST_FOR_PRODUCTION,
    UNSET_PENDING_SALE_ORDER_LIST_FOR_PRODUCTION,
    SET_ONGOING_SALE_ORDER_LIST_FOR_PRODUCTION,
    UNSET_ONGOING_SALE_ORDER_LIST_FOR_PRODUCTION,
    SET_COMPLETED_SALE_ORDER_LIST_FOR_PRODUCTION,
    UNSET_COMPLETED_SALE_ORDER_LIST_FOR_PRODUCTION,
} from "@/store/mutation-types";
import { 
    productionSaleOrderResource,
} from "@/store/api";

const state = {
    getPendingSaleOrderListForProduction: [],
    getOngoingSaleOrderListForProduction: [],
    getCompletedSaleOrderListForProduction: [],
};

const getters = {
    getPendingSaleOrderListForProduction(state) {
        return state.getPendingSaleOrderListForProduction;
    },
    getOngoingSaleOrderListForProduction(state) {
        return state.getOngoingSaleOrderListForProduction;
    },
    getCompletedSaleOrderListForProduction(state) {
        return state.getCompletedSaleOrderListForProduction;
    },
};

const mutations = {
    [SET_PENDING_SALE_ORDER_LIST_FOR_PRODUCTION](state, data) {
        state.getPendingSaleOrderListForProduction = data;
    },
    [UNSET_PENDING_SALE_ORDER_LIST_FOR_PRODUCTION](state) {
        state.getPendingSaleOrderListForProduction = [];
    },

    [SET_ONGOING_SALE_ORDER_LIST_FOR_PRODUCTION](state, data) {
        state.getOngoingSaleOrderListForProduction = data;
    },
    [UNSET_ONGOING_SALE_ORDER_LIST_FOR_PRODUCTION](state) {
        state.getOngoingSaleOrderListForProduction = [];
    },

    [SET_COMPLETED_SALE_ORDER_LIST_FOR_PRODUCTION](state, data) {
        state.getCompletedSaleOrderListForProduction = data;
    },
    [UNSET_COMPLETED_SALE_ORDER_LIST_FOR_PRODUCTION](state) {
        state.getCompletedSaleOrderListForProduction = [];
    },
};

const actions = {

    getPendingSaleOrderListForProduction({ commit }, params={}) {
        return new Promise((resolve, reject) => {
        Axios.get(productionSaleOrderResource, {params})
            .then(function (response) {
            commit('SET_PENDING_SALE_ORDER_LIST_FOR_PRODUCTION', response.data.data);
            resolve(response);
            })
            .catch(function (error) {
            commit('UNSET_PENDING_SALE_ORDER_LIST_FOR_PRODUCTION');
            reject(error);
            });
        });
    },

    getOngoingSaleOrderListForProduction({ commit }, params={}) {
        return new Promise((resolve, reject) => {
        Axios.get(productionSaleOrderResource, {params})
            .then(function (response) {
            commit('SET_ONGOING_SALE_ORDER_LIST_FOR_PRODUCTION', response.data.data);
            resolve(response);
            })
            .catch(function (error) {
            commit('UNSET_ONGOING_SALE_ORDER_LIST_FOR_PRODUCTION');
            reject(error);
            });
        });
    },

    getCompletedSaleOrderListForProduction({ commit }, params={}) {
        return new Promise((resolve, reject) => {
        Axios.get(productionSaleOrderResource, {params})
            .then(function (response) {
            commit('SET_COMPLETED_SALE_ORDER_LIST_FOR_PRODUCTION', response.data.data);
            resolve(response);
            })
            .catch(function (error) {
            commit('UNSET_COMPLETED_SALE_ORDER_LIST_FOR_PRODUCTION');
            reject(error);
            });
        });
    },


};

export default {
  state,
  getters,
  actions,
  mutations,
};

